import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'audit',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('r-customers', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      status: filter.status,
      area: filter.area,
      cluster: filter.cluster,
      officer: filter.officer,
      province: filter.province,
      municipality: filter.municipality,
      created_from: filter.created_from,
      created_to: filter.created_to,
      is_blo: filter.is_blo,
      is_aljay: filter.is_aljay,
      has_farm: filter.has_farm,
      has_crops: filter.has_crops
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('r-customers')
}

export {
  setTableOptions,
  getTableOptions
}
